/**
 * Created by Skeets on 2017/06/07.
 */

var currentQuestionCardNum = 0;

function getQuestion()
{

  var cardNum = currentQuestionCardNum;
  currentQuestionCardNum++;
  var grammarNum = Math.floor((Math.random() * grammars.length));
  var output     = {};

  output.answers = [];


  var wrongAnswers  = [];
  var correctAnswer = "";

  if (typeof cards[cardNum] === "undefined" || cards[cardNum] === null) {
    cardNum                = 0;
    currentQuestionCardNum = 1;
  }

  trackQuestion.card = cards[cardNum].id;
  output.xp          = cards[cardNum].xp;
  trackQuestion.side = cards[cardNum].sideID;
  if (output.xp > 7 && false) {
    // sentence writing....
  }
  else if (output.xp > 4) {

    if (userTargetLang !== "ja") {
      output.question = cards[cardNum].sideContent;
      correctAnswer   = cards[cardNum].value;
      wrongAnswers    = randomizeSpell(cards[cardNum].value, userTargetLang);

    }
    else {
      output.question = cards[cardNum].value;
      correctAnswer   = cards[cardNum].sideContent;
      wrongAnswers    = randomizeSpell(cards[cardNum].sideContent, userTargetLang);
    }
  }
  else {
    $flip = (Math.random() < 0.5);
    if ($flip) {
      output.question = cards[cardNum].sideContent;
      correctAnswer   = cards[cardNum].value;
      wrongAnswers    = getRandomAnswers(cards, "value", cards[cardNum].id);
    }
    else {
      output.question = cards[cardNum].value;
      correctAnswer   = cards[cardNum].sideContent;
      wrongAnswers    = getRandomAnswers(cards, "sideContent", cards[cardNum].id);
    }
  }

  // for grammar:
  // output.question = "以下の選択肢から選びなさい。";
  // wrongAnswers    = [grammars[grammarNum].one, grammars[grammarNum].two, grammars[grammarNum].three];
  // correctAnswer   = grammars[grammarNum].answer;

  var totalNum = wrongAnswers.length + 1;

  var posOfCorrect = Math.floor((Math.random() * totalNum));


  for (var x = 0; x < totalNum; x++) {
    if (x == posOfCorrect) {
      output.answers.push({content: correctAnswer, correct: true});
    }
    else {
      output.answers.push({content: wrongAnswers.shift(), correct: false});
    }
  }


  return output;


}


function getRandomAnswers(theseCards, type, avoidID)
{

  var answerNums = [];
  var answers    = [];
  var cardNum    = -1;
  var tries      = 50;
  outerLoop:
    while (answerNums.length < 3) {
      while (cardNum ===
             -1 ||
             answerNums.indexOf(cardNum) >
             -1 ||
             (typeof theseCards[cardNum] !== "undefined" &&
              typeof theseCards[cardNum].id !== "undefined" && theseCards[cardNum].id == avoidID)) {
        cardNum = Math.floor((Math.random() * theseCards.length));
        tries--;
        if (tries < 1) {
          break outerLoop;
        }
      }
      tries = 50;
      answerNums.push(cardNum);
      answers.push(theseCards[cardNum][type]);
    }
  return answers;

}

var commonMistakes         = {};
var possibleMistakesBackup = {};

commonMistakes.ja = {
  りょ : ["りょう"],
  りょう: ["りょ"],
  きょ : ["きょう"],
  きょう: ["きょ"],
  きゅう: ["きゅ"],
  きゅ : ["きゅう"],
  ゆ  : ["ゆう"],
  ゆう : ["ゆ"],
  よ  : ["よう"],
  よう : ["よ"],
  とお : ["とう", "と"],
  とう : ["とう", "と"],
  と  : ["とう", "とお"],
  つう : ["つ"],
  つ  : ["つう"],
  む  : ["むう"],
  ちゃ : ["ちゃあ"],
  ちゃあ: ["ちゃ"],
  そう : ["そ"],
  そ  : ["そう"],
  のう : ["の"],
  の  : ["のう"],
  ほ  : ["ほう"],
  ほう : ["ほ"],
  も  : ["もう"],
  もう : ["も"],
  ろ  : ["ろう"],
  ろう : ["ろ"],
  ちゅ : ["ちゅう"],
  ちゅう: ["ちゅ"]
};
commonMistakes.en = {
  ph: ["f"],
  ae: ["ea"],
  ie: ["ei"],
  ei: ["ie"],
  ck: ["k"],
  r : ["l"],
  l : ["r"],
  b : ["v"],
  v : ["b"],
  th: ["s"]
};


// This is just to make sure we have something to randomize!
possibleMistakesBackup.ja = {
  あ: ["い", "う", "え", "お"],
  い: ["あ", "う", "え", "お"],
  う: ["あ", "い", "え", "お"],
  え: ["あ", "い", "う", "お"],
  お: ["あ", "い", "う", "え"],
  か: ["が", "き", "く", "け", "こ"],
  き: ["ぎ", "か", "く", "け", "こ"],
  く: ["ぐ", "き", "か", "け", "こ"],
  け: ["げ", "き", "く", "か", "こ"],
  こ: ["ご", "き", "く", "け", "か"],
  さ: ["ざ", "し", "す", "せ", "そ"],
  し: ["じ", "さ", "す", "せ", "そ"],
  す: ["ず", "し", "さ", "せ", "そ"],
  せ: ["ぜ", "し", "す", "さ", "そ"],
  そ: ["ぞ", "し", "す", "せ", "さ"],
  ざ: ["さ", "じ", "ず", "ぜ", "ぞ"],
  じ: ["し", "ざ", "ず", "ぜ", "ぞ"],
  ず: ["す", "じ", "ざ", "ぜ", "ぞ"],
  ぜ: ["せ", "じ", "ず", "ざ", "ぞ"],
  ぞ: ["そ", "じ", "ず", "ぜ", "ざ"],
  た: ["だ", "ち", "つ", "て", "と"],
  ち: ["ぢ", "た", "つ", "て", "と"],
  つ: ["づ", "ち", "た", "て", "と"],
  て: ["で", "ち", "つ", "た", "と"],
  と: ["ど", "ち", "つ", "て", "た"],
  だ: ["た", "ぢ", "づ", "で", "ど"],
  ぢ: ["ち", "だ", "づ", "で", "ど"],
  づ: ["つ", "ぢ", "だ", "で", "ど"],
  で: ["て", "ぢ", "づ", "だ", "ど"],
  ど: ["と", "ぢ", "づ", "で", "だ"],
  な: ["に", "ぬ", "ね", "の"],
  に: ["な", "ぬ", "ね", "の"],
  ぬ: ["に", "な", "ね", "の"],
  ね: ["に", "ぬ", "な", "の"],
  の: ["に", "ぬ", "ね", "な"],
  は: ["ば", "ぱ", "ひ", "ふ", "へ", "ほ"],
  ひ: ["び", "ぴ", "は", "ふ", "へ", "ほ"],
  ふ: ["ぶ", "ぷ", "ひ", "は", "へ", "ほ"],
  へ: ["べ", "ぺ", "ひ", "ふ", "は", "ほ"],
  ほ: ["ぼ", "ぽ", "ひ", "ふ", "へ", "は"],
  ば: ["ぱ", "は", "ひ", "ふ", "へ", "ほ"],
  び: ["ぴ", "ひ", "は", "ふ", "へ", "ほ"],
  ぶ: ["ぷ", "ふ", "ひ", "は", "へ", "ほ"],
  べ: ["ぺ", "へ", "ひ", "ふ", "は", "ほ"],
  ぼ: ["ぽ", "ほ", "ひ", "ふ", "へ", "は"],
  ぱ: ["ば", "は", "ひ", "ふ", "へ", "ほ"],
  ぴ: ["び", "ひ", "は", "ふ", "へ", "ほ"],
  ぷ: ["ぶ", "ふ", "ひ", "は", "へ", "ほ"],
  ぺ: ["べ", "へ", "ひ", "ふ", "は", "ほ"],
  ぽ: ["ぼ", "ほ", "ひ", "ふ", "へ", "は"],
  ま: ["み", "む", "め", "も"],
  み: ["ま", "む", "め", "も"],
  む: ["み", "ま", "め", "も"],
  め: ["み", "む", "ま", "も"],
  も: ["み", "む", "め", "ま"],
  や: ["ゆ", "よ", "あ"],
  ゆ: ["や", "よ", "う"],
  よ: ["や", "ゆ", "お"],
  ら: ["り", "る", "れ", "ろ"],
  り: ["ら", "る", "れ", "ろ"],
  る: ["り", "ら", "れ", "ろ"],
  れ: ["り", "る", "ら", "ろ"],
  ろ: ["り", "る", "れ", "ろ"],
  わ: ["あ", "や"],
  を: ["お"],
  ん: ["な", "に", "ぬ", "ね", "の"]
};

possibleMistakesBackup.en = {
  a: ["e"],
  b: ["v", "d"],
  c: ["e"],
  d: ["b", "t"],
  e: ["c", "a"],
  f: ["ph"],
  g: ["j"],
  h: ["n"],
  i: ["e"],
  j: ["g"],
  k: ["c"],
  l: ["r"],
  m: ["n"],
  n: ["m"],
  o: ["u"],
  p: ["t"],
  q: ["u"],
  r: ["l"],
  s: ["z"],
  t: ["d"],
  u: ["o"],
  v: ["b"],
  w: ["y"],
  x: ["ecks"],
  y: ["i"],
  z: ["s"]
};

function randomizeSpell(stringToRandomize, lang)
{

  output = goThroughMistakeList(stringToRandomize, commonMistakes[lang], 3, []);


  if (output.length > 2) {
    return output;
  }


  output = goThroughMistakeList(stringToRandomize, possibleMistakesBackup[lang], 3, output);


  return output;

}


function goThroughMistakeList(stringToRandomize, list, numMistakes, output)
{

  var keys = [];
  for (var property in list) {
    if (list.hasOwnProperty(property)) {
      keys.push(property);
    }
  }

  keys = shuffle(keys);

  keys.forEach(function(key) {
    if (output.length >= numMistakes) {
      return output
    }

    var thisValue = list[key][0];

    var thisCandidate = stringToRandomize.replace(key, thisValue);

    if (thisCandidate != stringToRandomize && !inArray(output, thisCandidate)) {
      output.push(thisCandidate);
    }

  });

  return output;

}

function shuffle(array)
{
  var currentIndex = array.length, temporaryValue, randomIndex;

  while (0 !== currentIndex) {

    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    temporaryValue      = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex]  = temporaryValue;
  }

  return array;
}

function inArray(array, needle)
{
  for (var i = 0; i < array.length; i++) {
    if (array[i] === needle) {
      return true;
    }
  }
  return false;
}
